import { MenuItemType } from './MenuItemType';
import { Mapper, ReadOnly } from 'module/Common';
import { Localized } from 'module/Model/Localized';

export type MenuItemCategoryLink = ReadOnly<MenuItemCategoryLink.Shape>;

export namespace MenuItemCategoryLink {
  export interface Shape {
    type: MenuItemType;
    categoryId: number;
    name: Localized<string>;
  }

  const create = (input: MenuItemCategoryLink) => input;

  export const mapper = Mapper.mapSchema(
    {
      acf_fc_layout: Mapper.exact(MenuItemType.CategoryLink),
      link: Mapper.num,
      name: Localized.mapperWithDefault('Sans Nom', 'No Name'),
    },
    ({ link, name, acf_fc_layout }) => create({ categoryId: link, name, type: acf_fc_layout })
  );

  export const getCategoryId = (model: MenuItemCategoryLink): number => model.categoryId;
  export const getName = (model: MenuItemCategoryLink): Localized<string> => model.name;
}



// WEBPACK FOOTER //
// ./src/module/Model/Menu/item/MenuItemCategoryLink.ts